<div class="main-container-finance">
  <div class="breadcrumb">
    <a (click)="backToDashboard()" class="crumb crumb-link">Finance Dashboard</a>
    <span class="crumb-sep">/</span>
    <span class="crumb crumb-current">D&amp;T India Recharge Recovery</span>
  </div>

  <mat-card class="content-card">
    <div class="section-header">
      <div class="section-title">
        <mat-icon class="title-icon">event_note</mat-icon>
        <span>Holidays</span>
      </div>
      <div class="section-actions">
        <a class="calendar-link" (click)="openHolidayCalendar()">{{ currentYear }} Holidays Calendar</a>
        <mat-form-field appearance="outline" class="month-select">
          <mat-label>Select Month</mat-label>
          <mat-select [(value)]="selectedMonth" (selectionChange)="onMonthChange()">
            <mat-option *ngFor="let m of months" [value]="m.value">{{ m.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <ng-container *ngIf="loading">
      <ngx-skeleton-loader
        class="summary-skeleton"
        [theme]="{ height: '88px', 'border-radius': '8px', 'margin-bottom': '18px' }"
        appearance="line"
      ></ngx-skeleton-loader>
      <div class="city-cards">
        <ngx-skeleton-loader
          *ngFor="let i of [0, 1, 2]"
          [theme]="{ height: '92px', 'border-radius': '8px', 'margin-bottom': '0' }"
          appearance="line"
        ></ngx-skeleton-loader>
      </div>
      <div class="email-body-skeleton">
        <ngx-skeleton-loader count="2" [theme]="{ height: '14px', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader count="6" [theme]="{ height: '44px', 'margin-bottom': '4px' }"></ngx-skeleton-loader>
      </div>
    </ng-container>
    <div *ngIf="errorMessage" class="error-state">{{ errorMessage }}</div>

    <ng-container *ngIf="!loading && !errorMessage && monthData">
      <div class="summary-card">
        <div class="summary-left">
          <div class="count-num">{{ monthData.totalDays }}</div>
          <div class="count-meta">
            <div class="count-label">{{ monthData.totalDays === 1 ? 'Holiday' : 'Holidays' }}</div>
            <div class="month-label">{{ monthData.monthName }} {{ monthData.year }}</div>
          </div>
        </div>
        <div class="summary-dates">
          <div *ngFor="let item of monthData.summary" class="holiday-pill">
            <div class="holiday-date">
              <span class="day-num">{{ item.day }}</span>
              <span class="day-name">{{ item.dayName | slice:0:3 }}</span>
            </div>
            <div class="holiday-name">{{ item.holidayName }}</div>
          </div>
          <span *ngIf="monthData.summary.length === 0" class="no-holidays">No holidays this month</span>
        </div>
      </div>

      <div class="city-cards">
        <div class="city-card city-hyderabad">
          <div class="city-card-header">
            <mat-icon class="city-icon">event</mat-icon>
            <span>Hyderabad Holidays on</span>
          </div>
          <div class="city-card-dates">{{ formatDayList(monthData.cityHolidays.hyderabad.dates) }}</div>
        </div>
        <div class="city-card city-gurugram">
          <div class="city-card-header">
            <mat-icon class="city-icon">event</mat-icon>
            <span>Gurugram Holidays on</span>
          </div>
          <div class="city-card-dates">{{ formatDayList(monthData.cityHolidays.gurugram.dates) }}</div>
        </div>
        <div class="city-card city-noida">
          <div class="city-card-header">
            <mat-icon class="city-icon">event</mat-icon>
            <span>Noida Holidays on</span>
          </div>
          <div class="city-card-dates">{{ formatDayList(monthData.cityHolidays.noida.dates) }}</div>
        </div>
      </div>

      <div class="email-body" *ngIf="schedule">
        <p class="greeting">Hello Leaders,</p>
        <p>Please find below the <strong>{{ monthYearShort(schedule) }}</strong> calendar for D&amp;T India Cost Recovery.</p>
        <p>We look forward to your continued support in helping us adhere to the defined timelines.</p>

        <table class="action-items-table">
          <thead>
            <tr>
              <th>Timelines &amp; Last Dates</th>
              <th>Action Items</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of actionItems" [class.highlight]="row.highlight">
              <td class="date-cell">{{ row.dateLabel }}</td>
              <td class="action-cell">{{ row.actionItem }}</td>
            </tr>
          </tbody>
        </table>

        <div class="send-row">
          <button class="send-btn" type="button" (click)="openSendConfirm()" [disabled]="sending">
            {{ sending ? 'Sending…' : 'Send' }}
          </button>
        </div>
      </div>
    </ng-container>
  </mat-card>
</div>
